export const zeroRelationWithNames = {
    id: undefined,
    person_id: undefined,
    stage_name: "",
    vacancy_id: undefined,
    vacancy_name: "",
    deleted: false,
}